// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environments = {
  dev: {
    production: false,
    sendEvents: false,
    videoDeliveryApiUrl: 'https://api.dev.engageone.video',
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
  dev2: {
    production: false,
    sendEvents: false,
    videoDeliveryApiUrl: 'https://api.dev2.engageone.video',
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
  dev3: {
    production: false,
    sendEvents: false,
    videoDeliveryApiUrl: 'https://api.dev3.engageone.video',
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
  qa: {
    production: false,
    sendEvents: true,
    videoDeliveryApiUrl: {
      'us-east-1': 'https://api.qa.engageone.video',
      'eu-central-1': 'https://api.qa.eu-central-1.engageone.video',
    },
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
  production: {
    production: true,
    sendEvents: true,
    videoDeliveryApiUrl: {
      'us-east-1': 'https://api.engageone.video',
      'eu-central-1': 'https://api.eu-central-1.engageone.video',
      'eu-west-2': 'https://api.eu-west-2.engageone.video',
      'ap-southeast-2': 'https://api.ap-southeast-2.engageone.video'
    },
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
  sectest: {
    production: true,
    sendEvents: true,
    videoDeliveryApiUrl: 'https://api.sectest.engageone.video',
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
  staging: {
    production: true,
    sendEvents: true,
    videoDeliveryApiUrl: 'https://api.staging.engageone.video',
    assetsCdnUrl: 'https://player.engageone.video',
    performanceBuild: true
  },
};

export const environment = environments[(window as any).stageName] || environments.production;

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
